'use client';
import { EventsByCategory } from '@/components/common';
import { useCategoryEvents } from './hooks';

const HomeEventsSection = () => {
  const { data, loading, loadMoreEvents } = useCategoryEvents();

  return (
    <div>
      {data?.map((item: any) => {
        if (item?.events?.length > 0) {
          return (
            <EventsByCategory
              key={item._id}
              colorScheme={'light'}
              heading={item.carouselTitle}
              subHeading={item.carouselSubtitle}
              data={!loading ? item.events : null}
              onEndReached={() => loadMoreEvents(item.categoryCode)}
              hasMore={item.hasMore}
              loadingMore={item.refreshing}
            />
          );
        }
      })}
    </div>
  );
};

export default HomeEventsSection;
